// Google Form Configuration
// Replace these values with your actual Google Form details

export const GOOGLE_FORM_CONFIG = {
  // Your Google Form URL
  formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfSqj5gPcQm0e3ajdxf9RJkXaplf4xqNOzKvAzUweUCE8fzbw/formResponse',
  
  // Field IDs for each form field (get these from your Google Form HTML)
  // To get field IDs: Right-click on your form -> View Page Source -> Search for "entry."
  fieldIds: {
    name: 'entry.2033206860',           // Full Name field ID
    email: 'entry.493107553',          // Email Address field ID
    phone: 'entry.2097956754',          // Phone Number field ID
    address: 'entry.1290754826',        // Address field ID
    resume: 'entry.836197599',         // Resume/CV field ID
    role: 'entry.1943948032',           // Preferred Role field ID
    education: 'entry.180230733',      // Education field ID
    subjects: 'entry.802207956',       // Subjects field ID
    year: 'entry.414847521',           // Passout Year field ID
    college: 'entry.1367199786',        // College/University field ID
    state: 'entry.506283408',          // State field ID
    district: 'entry.1976946879',       // District field ID
    marks_10th: 'entry.719448741',    // 10th Standard Marks field ID
    marks_degree: 'entry.870482329',  // Degree Marks field ID
    source: 'entry.1120419332',         // Source of Information field ID
    source_other: 'entry.193401353',  // Please Specify field ID
    about_techpuram: 'entry.834453656' // What do you know about Techpuram field ID
  }
};

// GitHub Repository Configuration for Resume Storage
export const GITHUB_CONFIG = {
  // Your GitHub repository details
  owner: 'iyaltamizh',
  repo: 'internship_resumes',
  branch: 'main',
  
  // GitHub API endpoints
  apiUrl: 'https://api.github.com',
  uploadUrl: 'https://api.github.com/repos/{owner}/{repo}/contents/{path}',
  
  // File storage path in repository
  filePath: 'resumes/',
  
  // GitHub Personal Access Token (REQUIRED)
  // Get this from: GitHub → Settings → Developer settings → Personal access tokens
  // Required permissions: repo (Full control of private repositories)
  token: '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', // Add your token here
};



// Instructions:
// 1. Create a Google Form with all the required fields
// 2. Right-click on your form and "View Page Source"
// 3. Search for "entry." to find the field IDs
// 4. Replace the placeholder values above with your actual field IDs
// 5. Update the formUrl with your Google Form URL
